{
  "signerIdentities": {
    "identityHeaders": {
      "dataPlatform": "Gegevens bekend",
      "externalData": "iDIN gegevens",
      "validate": "Controle",
      "summary": "Samenvatting",
      "check": "Controle",
      "finalCheck": "Eindcontrole"
    },
    "messages": {
      "signerValidationStatus": {
        "noVerification": "Verificatie niet uitgevoerd",
        "verifiedByIdin": "Geverifieerd door iDIN",
        "manualVerified": "Handmatig geverifieerd door {name} op {at}",
        "idinManualVerified": "iDIN klopt, geverifieerd door {name} op {at}"
      },
      "noIdinVerification": "Contract is handmatig verzonden, of digitaal zonder iDIN. Je dient dit handmatig te controleren"
    },
    "actions": {
      "idinCorrect": "iDIN correct",
      "manualApproval": "Handmatig goedkeuren",
      "finalCheckCompleted": "Alle bevoegdheden van de ondertekenaars zijn gecontroleerd en gevalideerd op volledigheid en juistheid."
    }
  },
  "files": {
    "titles": {
      "files": "Documenten"
    },
    "archivedVersions": "Gearchiveerde versies ({number})",
    "messages": {
      "cannotBeDisplayed": "Het document kan niet ingeladen worden.",
      "noFiles": "Geen documenten beschikbaar"
    }
  },
  "messages": {
    "messageBox": {
      "titles": {
        "messageBoxTitle": "Bericht verzonden aan klant"
      },
      "fields": {
        "labels": {
          "type": "Type",
          "sentAt": "Verzonden op",
          "receivers": "Ontvangers",
          "subject": "Onderwerp",
          "body": "Bericht"
        }
      },
      "messages": {
        "cannotBeDisplayed": "Het bericht kan niet ingeladen worden."
      }
    },
    "messageTable": {
      "fields": {
        "labels": {
          "channel": "Soort",
          "sentAt": "Datum",
          "subject": "Onderwerp",
          "receivers": "Gebruiker(s)"
        }
      }
    }
  },
  "companySearch": {
    "fields": {
        "labels": {
          "name": "Bedrijfsnaam",
          "registrationNumber": "KvK- of registratienummer",
          "branchNumber": "Vestigingsnummer",
          "address": "Adres"
        }
      },
      "resultItem": {
          "registrationNumber": "KvK-/reg.nr.",
          "branchNumber": "Vestigingsnr."
      }
  }
}
